import "./Dashboard.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Card_design } from "./Card_design";

export function Dashboard() {
  const [alldata, setalldata] = useState(null);
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";
  console.log("All tables data1", alldata);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const algorithms = alldata?.algorithms || [];

  const rankedAlgorithms = [...algorithms].sort(
    (a, b) => Number(b.algorithim_confidence) - Number(a.algorithim_confidence)
  );

  const weakeningAlgorithms = rankedAlgorithms
    .filter((algorithm) => Number(algorithm.algorithim_confidence) < 50)
    .sort(
      (a, b) =>
        Number(a.algorithim_confidence) - Number(b.algorithim_confidence)
    );

  useEffect(() => {
    const fetchAllTeams = async () => {
      try {
        const response = await fetch(
          `${API_URL}/pastresult/getAllTableOnce`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();

        setalldata(data?.final_return_data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAllTeams();
  }, []);

  // EXPORT BUTTON
  const exportMatchesToExcel = (data) => {
    if (!data || !Array.isArray(data.all_data) || data.all_data.length === 0) {
      alert("No data to export");
      return;
    }

    const matches = data.all_data; // Access the array via index

    const rows = matches.map((m, index) => ({
      League: m.League,
      Schedule: m.Schedule,

      Home_Team: m.Home_Team,
      Away_Team: m.Away_Team,

      Home_Score: m.Home_score,
      Away_Score: m.Away_score,

      General_H_ExpG: m.general_H_exp_g,
      General_A_ExpG: m.general_A_exp_g,
      General_CS_1: m.general_CS_1,
      General_CS_2: m.general_CS_2,

      Odds_H_ExpG: m.odds_H_exp_g,
      Odds_A_ExpG: m.odds_A_exp_g,
      Odds_CS_1: m.odds_CS_1,
      Odds_CS_2: m.odds_CS_2,

      Form_H_ExpG: m.form_H_exp_g,
      Form_A_ExpG: m.form_A_exp_g,
      Form_CS_1: m.form_CS_1,
      Form_CS_2: m.form_CS_2,

      Home_Mean: m.H_mean,
      Away_Mean: m.A_mean,

      Home_CV: m.H_cv,
      Away_CV: m?.A_cv,
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Match Analytics");

    XLSX.writeFile(workbook, "Match_Analytics.xlsx");
  };

  if (loading) return <p> Fetching Data ..... </p>;
  if (error) return <p>Error :: {error}</p>;
  return (
    <>
      <div className="alg1_card">
        {/* start :: main section card */}
        {/* header section  */}
        <div className=" dashboard_header">
          <span>ANALYTICS DASHBOARD</span>
        </div>

        <button
          className="export_excel_btn"
          onClick={() => exportMatchesToExcel(alldata)}
        >
          Export to Excel
        </button>

        {alldata && (
          <>
            <div className="algorithim_cards">
              <div className="algorithim_cards">
                {alldata?.algorithms?.map((algorithm) => (
                  <div
                    className="algorithim_card_section"
                    key={algorithm.Algorithim_Name}
                  >
                    <Card_design
                      title={algorithm.Algorithim_Name}
                      total_count={algorithm.Total_mathches}
                      percentage={algorithm.overall_accuracy}
                      correct_count={algorithm.correct_matches}
                      confidence={algorithm.algorithim_confidence}
                      trend_direction={algorithm.trend_direction}
                      trend_change={algorithm.trend_change}
                    />
                  </div>
                ))}
              </div>
              <div className="trending_section">
                <div className="trend_header">
                  <h2>Algorithm Trending</h2>

                  <span>Ranked by confidence</span>
                </div>

                <div className="trend_list">
                  {rankedAlgorithms.length > 0 ? (
                    rankedAlgorithms.map((algorithm, index) => {
                      const confidence =
                        Number(algorithm.algorithim_confidence) || 0;

                      const change = Number(algorithm.trend_change) || 0;

                      const direction = algorithm.trend_direction || "stable";

                      return (
                        <div
                          className="trend_item"
                          key={algorithm.Algorithim_Name}
                        >
                          <div className="trend_rank">#{index + 1}</div>

                          <div className="trend_algorithm">
                            <strong>{algorithm.Algorithim_Name}</strong>

                            <span>Accuracy: {algorithm.overall_accuracy}%</span>
                          </div>

                          <div className="trend_confidence">
                            <strong>{confidence.toFixed(1)}%</strong>

                            <span>Confidence</span>
                          </div>

                          <div className={`trend_direction ${direction}`}>
                            {direction === "improving" && "↑"}

                            {direction === "weakening" && "↓"}

                            {direction === "stable" && "→"}

                            <span>{direction}</span>

                            {change !== 0 && (
                              <small>
                                {change > 0 ? "+" : ""}
                                {change.toFixed(1)}%
                              </small>
                            )}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p className="no_algorithms">
                      No algorithm data available.
                    </p>
                  )}
                </div>

                {/* =====================================================
      WEAKENING
      ===================================================== */}

                <div className="weakening_section">
                  <div className="trend_header">
                    <h2>Weakening Algorithms</h2>

                    <span>Confidence below 50%</span>
                  </div>

                  {weakeningAlgorithms.length > 0 ? (
                    weakeningAlgorithms.map((algorithm, index) => (
                      <div
                        className="weakening_item"
                        key={algorithm.Algorithim_Name}
                      >
                        <div className="weakening_rank">#{index + 1}</div>

                        <div className="weakening_name">
                          <strong>{algorithm.Algorithim_Name}</strong>

                          <span>
                            Confidence:{" "}
                            {Number(algorithm.algorithim_confidence).toFixed(1)}
                            %
                          </span>
                        </div>

                        <div className="weakening_change">
                          ↓{" "}
                          {Math.abs(Number(algorithm.trend_change)).toFixed(1)}%
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="no_weakening">
                      ✓ No algorithms currently below 50%
                    </div>
                  )}
                </div>

                {/* =====================================================
      RECOMMENDATIONS
      ===================================================== */}

                <div className="recommendation_section">
                  <div className="trend_header">
                    <h2>Recommendations</h2>
                  </div>

                  {weakeningAlgorithms.length > 0 ? (
                    weakeningAlgorithms.slice(0, 3).map((algorithm) => {
                      const confidence =
                        Number(algorithm.algorithim_confidence) || 0;

                      const change = Number(algorithm.trend_change) || 0;

                      let recommendation;

                      if (confidence < 30) {
                        recommendation =
                          "Consider reviewing the algorithm conditions. Its recent performance is very weak.";
                      } else if (change < -10) {
                        recommendation =
                          "Performance is declining significantly. Review recent matches and consider adjusting the conditions.";
                      } else {
                        recommendation =
                          "Monitor this algorithm closely and collect more results before making condition changes.";
                      }

                      return (
                        <div
                          className="recommendation_item"
                          key={algorithm.Algorithim_Name}
                        >
                          <div className="recommendation_icon">!</div>

                          <div>
                            <strong>{algorithm.Algorithim_Name}</strong>

                            <p>{recommendation}</p>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="recommendation_good">
                      ✓ All algorithms are currently performing above the 50%
                      confidence threshold.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}

        {/* end :: main section card */}
      </div>
    </>
  );
}
